import { FormLayout } from "@careinfo/layout";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm, UseFormSetError } from "react-hook-form";
import { IPopup } from "../../types/interface";
import { popupValidation } from "../../utils/validationSchema";
import PageForm from "./Form";

interface Props {
  handleCreate: (
    data: IPopup,
    setError: UseFormSetError<IPopup>
  ) => Promise<void>;
  isCreatingPopupModal: boolean;
}

export default function CreatePage({
  handleCreate,
  isCreatingPopupModal,
}: Props) {
  const createPopupMethods = useForm<IPopup>({
    resolver: yupResolver(popupValidation),
  });

  return (
    <FormLayout
      isLoading={isCreatingPopupModal}
      handleSubmit={createPopupMethods.handleSubmit}
      handleFormSubmit={handleCreate}
      buttonLabel="Create"
      disabled={isCreatingPopupModal}
      setError={createPopupMethods.setError}
    >
      <FormProvider {...createPopupMethods}>
        <PageForm />
      </FormProvider>
    </FormLayout>
  );
}
